module.exports = __webpack_public_path__ + "img/solution0.45d77784.png";